import React from 'react';
import { IonButtons, IonImg } from '@ionic/react';
import Facebook from '../../assets/images/footer/Facebook.svg';
import Instagram from '../../assets/images/footer/Instagram.svg';
import Linkedin from '../../assets/images/footer/Linkedin.svg';
import Twitter from '../../assets/images/footer/Twitter.svg';

import './SocialMedia.scss';

const SocialMedia: React.FC = () => {
  return (
    <IonButtons class="social-media-group">
      <IonImg className="sportbook-img" src={Facebook} />
      <IonImg className="sportbook-img" src={Instagram} />
      <IonImg className="sportbook-img" src={Linkedin} />
      <IonImg className="sportbook-img" src={Twitter} />
    </IonButtons>
  );
};

export default SocialMedia;
